import clsx from 'clsx';

import { Icon } from '@atom/mui';
import { LensIcon } from '@atom/mui/icons';

import classes from './colorSwatchGrid.module.css';

type ColorSwatchGridProps = {
  colorId: number;
  colors: string[];
  onChange: (id: number) => void;
};

const ColorSwatchGrid = ({
  colorId,
  colors,
  onChange,
}: ColorSwatchGridProps) => (
  <div className={classes.container} data-cy="colorSwatchGrid">
    {colors.map((swatch, index) => (
      <div
        key={swatch + index}
        className={clsx(classes.swatch, index === colorId && classes.selected)}
        onClick={() => onChange(index)}
        data-cy={`colorSwatch-${index}`}
      >
        <Icon style={{ fontSize: '30px' }} color={swatch} icon={LensIcon} />
      </div>
    ))}
  </div>
);

export default ColorSwatchGrid;
